import { Box, Tab } from '@material-ui/core';
import React from 'react';

import { TabsWithBlueIndicator } from '~/src/dash/components/model-tab';
import { publicaColors } from '~/src/dash/utils/colors';

const tabProps = (tabNumber: number) => {
  return {
    id: `simple-tab-${tabNumber}`,
    'aria-controls': `simple-tabpanel-${tabNumber}`,
  };
};

interface IIASDashboardTabsProps {
  currentTab: number;
  onChange: () => void;
  tabs: string[];
  value: number;
}

export const IASDashboardTabs = ({ currentTab, onChange, tabs, value }: IIASDashboardTabsProps) => {
  return (
    <Box style={{ borderBottom: 1 }}>
      <TabsWithBlueIndicator onChange={onChange} value={value}>
        {tabs.map((tab, index) => {
          return (
            <Tab
              label={tab}
              style={{ color: index === currentTab ? publicaColors.lightBlue : '' }}
              {...tabProps(index)}
            />
          );
        })}
      </TabsWithBlueIndicator>
    </Box>
  );
};
